import React from "react"
import DeviceTable from "../../../components/device/DeviceTable"
import TableActionBar from "../../../components/layout/TableActionBar"
import AddDeviceDialog from "../../../components/device/AddDeviceDialog"
import { FloatingActionButton, CircularProgress } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { IUserDocument, IDeviceDocument, EAddDeviceValidationType, IDeviceReportColumns, IUIUser } from "../../../models"
import AppStateStore from "../../../stores/AppStateStore"
import * as api from "../../../api"
interface IProps {
    user: IUserDocument
    addDevicePermission: boolean
    editDevicePermission: boolean
    deleteDevicePermission: boolean
}
interface IState {
    loading: boolean
    devices: IDeviceDocument[]
    searchText: string
    selectedDevices: IDeviceDocument[]
    offset: number
    limit: number
    editDevice: IDeviceDocument
    openAddDeviceDialog: boolean
}

export default class UserDetailsDevice extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            loading: true,
            devices: [],
            searchText: "",
            selectedDevices: [],
            offset: 0,
            limit: 50,
            editDevice: null,
            openAddDeviceDialog: false,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getDevices()
    }

    getDevices() {
        api.getUserDevices(this.props.user.Id).then(res =>
            this.setState({
                loading: false,
                devices: res.data,
                searchText: "",
                selectedDevices: [],
                offset: 0
            })
        )
    }

    handleAddDevice(device) {
        device.UserId = this.props.user.Id
        device.Type = 0
        return api.addUserDevice(this.props.user.Id, device).then(res => {
            const result = res.data as EAddDeviceValidationType
            if (result === EAddDeviceValidationType.Valid) {
                this.getDevices()
                AppStateStore.setProgressSnackbarContent(strings.Device_registered_successfully)
            }
            else {
                AppStateStore.setProgressSnackbarContent("")
            }
            return result
        })
    }

    handleEditDevice(device) {
        device.UserId = this.props.user.Id
        device.Type = 0
        return api.patchDevice(device).then(
            res => {
                this.getDevices()
                AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
                return res.data ? true : false
            },
            () => {
                AppStateStore.setProgressSnackbarContent(strings.Failed_to_update_device)
                return false
            }
        )
    }

    handleDeleteDevice() {
        AppStateStore.setProgressSnackbarContent("loading")
        setTimeout(() => {
            Promise.all(this.state.selectedDevices.map(device => api.deleteUserDevice(this.props.user.Id, device.Id))).then(() => {
                this.getDevices()
                AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
            })
        }, 1000)
    }

    render() {
        const searchText = this.state.searchText.toLowerCase()
        const filteredDevices = this.state.devices.filter(item => item.Name.toLowerCase().includes(searchText.toLowerCase()) || item.RegistrationCode.toLowerCase().includes(searchText.toLowerCase()))
        const viewableDevices = filteredDevices.slice(this.state.offset, Math.min(this.state.offset + this.state.limit, filteredDevices.length))
        return (
            <div className="detail-tab">
                <div className="UserDetailsDevices" style={{ position: "relative" }}>
                    {this.state.loading ?
                        <div className="spinner">
                            <CircularProgress />
                        </div> :
                        <div>
                            {this.props.addDevicePermission &&
                                <FloatingActionButton
                                    data-intercom-target={"menu-Employees-Devices-Btn-Add"}
                                    style={{ position: "relative", float: "right", right: 50, top: -45 }}
                                    secondary
                                    onTouchTap={() => this.setState({ openAddDeviceDialog: true })}
                                >
                                    <ContentAdd />
                                </FloatingActionButton>
                            }
                            <TableActionBar
                                rowSelectionCount={this.state.selectedDevices.length}
                                singleSelectedMessage={strings.Device_Selected}
                                multipleSelectedMessage={strings.x_Devices_Selected}
                                title={strings.Devices}
                                onSearch={searchText => this.setState({ searchText, offset: 0 })}
                                searchText={""}
                                onDeleteClick={() =>
                                    AppStateStore.setConfirmDialogContent({
                                        title: this.state.selectedDevices.length > 1 ? strings.Delete_Selected_Devices : strings.Delete_Device,
                                        content: this.state.selectedDevices.length > 1 ? strings.Are_you_sure_delete_devices : strings.Are_you_sure_delete_device,
                                        confirm: () => this.handleDeleteDevice()
                                    })
                                }
                                readonly={!this.props.deleteDevicePermission}
                            />
                            <DeviceTable
                                devices={viewableDevices}
                                selectedDevices={this.state.selectedDevices}
                                page={this.state.offset}
                                limit={this.state.limit}
                                limitOptions={[50, 100, 200]}
                                total={filteredDevices.length}
                                deviceColumns={{
                                    IncludeName: true,
                                    IncludeHomeHierarchy: true,
                                    IncludeConnected: true,
                                    IncludeType: true,
                                    IncludeCode: true,
                                    IncludeMode: true,
                                    IncludeOS: true,
                                    IncludePhoneNumber: false,
                                    IncludeDescription: true,
                                    IncludeAppVersion: true,
                                    IncludeActive: true,
                                    IncludeDevicePermissions: true
                                } as IDeviceReportColumns}
                                handleSelect={selectedDevices => this.setState({ selectedDevices })}
                                onRowClick={editDevice => {
                                    if (!this.props.editDevicePermission) return
                                    this.setState({
                                        openAddDeviceDialog: true,
                                        editDevice
                                    })
                                }}
                                onPageClick={offset => this.setState({ offset, selectedDevices: [] })}
                                onLimitChange={limit => this.setState({ limit, offset: 0, selectedDevices: [] })}
                                editPermission={this.props.editDevicePermission}
                                selectPermission={this.props.deleteDevicePermission}

                            />
                        </div>
                    }
                    {this.state.openAddDeviceDialog &&
                        <AddDeviceDialog
                            readonly={!this.props.editDevicePermission}
                            employeeForIndividual={this.props.user as IUIUser}
                            editableDevice={this.state.editDevice}
                            handleAdd={this.handleAddDevice}
                            handleUpdate={this.handleEditDevice}
                            handleClose={() =>
                                this.setState({
                                    openAddDeviceDialog: false,
                                    editDevice: null
                                })
                            }
                        />
                    }
                </div>
            </div>
        )
    }
} 